export default "__VITE_ASSET__Ev4CqouC__"